import { $can, $isAdmin, $isSuperAdmin, $hasFeature } from '@/core/utils/VueAcl'

export default {
  sectionName: 'LeftNavigation_SettingsMenu',
  icon: 'navigation-settings',
  index: '8',
  isAllowed: () =>
    $can('manageProjectTechnical') || $can('viewProjectTechnical'),
  subItems: [
    {
      sectionName: 'LeftNavigation_ProjectSettings',
      index: '8-1',
      routeName: 'ProjectSettings',
      subRouteName: ['ProjectCreate']
    },
    {
      sectionName: 'LeftNavigation_Applications',
      index: '8-2',
      routeName: 'Applications',
      subRouteName: [
        'ApplicationsList',
        'ApplicationDevTeam',
        'ApplicationCreate',
        'ApplicationUpdate',
        'ApplicationChannels',
        'ApplicationView',
        'ApplicationSDKIntegration'
      ]
    },
    {
      sectionName: 'LeftNavigation_ChannelSettingsPage',
      index: '8-6',
      routeName: 'EnableChannelsTab',
      subRouteName: [
        'EnableChannelsTab',
        'EngagementRulesTab',
        'UrlTrackingTab',
        'SmsFromNameTab',
        'PushSettingsTab'
      ]
    },
    {
      sectionName: 'LeftNavigation_SeedList',
      index: '8-8',
      routeName: 'SeedList',
      isAllowed: () =>
        $hasFeature('featureSeedList') &&
        $hasFeature('seedListEnabled') &&
        $can('viewProjectTechnical')
    },
    {
      sectionName: 'LeftNavigation_Integrations',
      index: '8-3',
      subItems: [
        {
          sectionName: 'LeftNavigation_ApiIntegration',
          index: '8-3-1',
          isAllowed: () => $can('manageProjectTechnical'),
          routeName: 'ApiIntegration'
        },
        {
          sectionName: 'LeftNavigation_SshKeyManagement',
          index: '8-3-5',
          isAllowed: () =>
            $can('manageProjectTechnical') || $can('viewProjectTechnical'),
          routeName: 'SshKeyManagement'
        },
        {
          sectionName: 'LeftNavigation_GoogleAnalyticsSettings',
          index: '8-3-2',
          routeName: 'GoogleAnalyticsSettings',
          isAllowed: () => $hasFeature('googleAnalytics')
        },
        {
          sectionName: 'LeftNavigation_ChannelsIntegrations',
          index: '8-3-3',
          isAllowed: () => $isAdmin(),
          routeName: 'ChannelList',
          subRouteName: ['ChannelCreate', 'ChannelUpdate']
        },
        {
          sectionName: 'LeftNavigation_IntegrationsMarketplace',
          index: '8-3-4',
          routeName: 'IntegrationsMarketplace'
        }
      ]
    },
    {
      sectionName: 'LeftNavigation_Advanced',
      index: '8-4',
      subItems: [
        {
          sectionName: 'LeftNavigation_ProjectFeatures',
          index: '8-4-9',
          isAllowed: () => $can('ProjectFeatureFlags::Read'),
          routeName: 'ProjectFeatures'
        },
        {
          sectionName: 'LeftNavigation_Translations',
          index: '8-4-1',
          routeName: 'Translations'
        },
        {
          sectionName: 'LeftNavigation_Alarms',
          index: '8-4-2',
          routeName: 'AlarmList',
          subRouteName: ['AlarmUpdate', 'AlarmCreate', 'AlarmView']
        },
        {
          sectionName: 'LeftNavigation_Queues',
          index: '8-4-7',
          routeName: 'QueueStatus',
          isAllowed: () => $hasFeature('queueStatus')
        },
        {
          sectionName: 'LeftNavigation_DataRetention',
          index: '8-4-3',
          isAllowed: () => $can('DataRetention:ReadAccess'),
          routeName: 'DataRetentionOverview'
        },
        {
          sectionName: 'LeftNavigation_SegmentationSettings',
          index: '8-4-4',
          isAllowed: () => $isSuperAdmin(),
          routeName: 'SegmentationSettings'
        },
        {
          sectionName: 'LeftNavigation_StreamingSettings',
          index: '8-4-12',
          isAllowed: () => $isSuperAdmin(),
          routeName: 'StreamingSettings'
        },

        {
          sectionName: 'WebFont_Title',
          index: '8-4-5',
          isAllowed: () =>
            $hasFeature('email') &&
            ($can('WebFont:FullAccess') || $can('WebFont:ReadAccess')),
          routeName: 'WebFontSettings'
        },
        {
          sectionName: 'LeftNavigation_CustomerIntelligence_Settings',
          index: '8-4-6',
          isAllowed: () => $isSuperAdmin(),
          routeName: 'CustomerIntelligenceSettings'
        },
        {
          sectionName: 'LeftNavigation_LoyaltySettings',
          index: '8-4-8',
          isAllowed: () => $isSuperAdmin(),
          routeName: 'LoyaltySettings'
        },
        {
          sectionName: 'LeftNavigation_OpenLiveActivities',
          index: '8-4-10',
          isAllowed: () => $hasFeature('openLiveActivities') && $isSuperAdmin(),
          routeName: 'OpenLiveActivitiesSettings'
        },
        {
          sectionName: 'LeftNavigation_DatabaseSourceSettings',
          index: '8-4-11',
          isAllowed: () => $isSuperAdmin(),
          routeName: 'DatabaseSourceSettings'
        },
        {
          sectionName: 'LeftNavigation_InternalApiDocs',
          index: '8-4-13',
          isAllowed: () => $isSuperAdmin(),
          routeName: 'InternalApiDocs'
        }
      ]
    }
  ]
}



// WEBPACK FOOTER //
// ./src/common/components/navigation/navigation-section-items/settings.js